// extracted by mini-css-extract-plugin
export default {"mainTitle":"Strategies_mainTitle__H8JWl"};